import {http} from "./api/restApiClient";
import {ApiResponse} from "apisauce";

export type SsoConfigurationRequest = {
  idpClient: string;
  certificate: string;
  issuerUrl: string;
  samlEndpoint: string;
  sloEndpoint: string;
};

export type SsoConfigurationResponse = SsoConfigurationRequest & {
  entityId: string;
  acsUrl: string;
  ssoEnabled: boolean;
  ssoExcludeRequiredRoles: string[] | null;
};

export type CreateSsoConfigurationRequest = SsoConfigurationRequest;
export type UpdateSsoConfigurationRequest = SsoConfigurationRequest;

export type ManageSsoConfigurationRequest = {
  ssoEnabled: boolean;
  ssoExcludeRequiredRoles: string[] | null;
};

export const SsoService = {
  getConfiguration: (
    organizationId: string,
  ): Promise<ApiResponse<SsoConfigurationResponse>> =>
    http.get(`/sso/configurations/${organizationId}`),

  createConfiguration: (
    organizationId: string,
    data: CreateSsoConfigurationRequest,
  ): Promise<ApiResponse<SsoConfigurationResponse>> =>
    http.post(`/sso/configurations/${organizationId}/create`, data),

  updateConfiguration: (
    organizationId: string,
    data: UpdateSsoConfigurationRequest,
  ): Promise<ApiResponse<SsoConfigurationResponse>> =>
    http.put(`/sso/configurations/${organizationId}/update`, data),

  manageConfiguration: (
    organizationId: string,
    data: ManageSsoConfigurationRequest,
  ): Promise<ApiResponse<void>> =>
    http.patch(`/sso/configurations/${organizationId}/manage`, data),
};
